import React, { useState, useEffect } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, Table, Modal, ModalHeader, ModalBody, CardHeader, Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap";
import TableContainer from "../../../../components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import user1 from "assets/images/brands/user1.jpg";
import CustomSelect from "components/Common/custom-select";
import Select from 'react-select';
import CustomDatePicker from "common/CustomDatePicker";
import { toast } from "react-hot-toast";
const toastId = 'select-one-error';
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchEmployees,
  fetchLoginDetails, fetchEmployeeMobilePunch, fetchBreakingList, updateMobilePunchApprovalRequest, resetMobilePunchApprovals,
  fetchEmployeeMobilePunchApprovalList,
  resetPunchEmployeeApprovalsList,
  fetchEmployeeDropdownAutoList,
  fetchEmployeeDropdownAutoListMobilePunch
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { FaCheck } from "react-icons/fa";
import Loader from "common/pageLoader";
import { useLocation, useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";
import { showToast, showConfirm } from "../../../../common/Toaster";

const BiometricMobilePunch = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [accessRight, setAccessRight] = useState(null);
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [breakingmodal, setBreakingModal] = useState(false);
  const [breakingDataList, setBreakingDataList] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  // const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [openId, setOpenId] = useState(false);
  const [punchApprovalData, setPunchApprovalData] = useState();
  const [timesheetApprovalData, setTimesheetApprovalData] = useState();
  // const location = useLocation();
  const history = useHistory();
  const {
    categories,
    departments,
    designations,
    employees,
    employeeMobilePunch,
    employeeMobilePunchaAppList,
    employeeBreakings,
    // dropdownAutoList,
    dropdownAutoMobilepunchList,
    loading,
    error,
    success,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    employees: state.LoginCreation?.loginDetails,
    employeeBreakings: state.AttendanceBiometricReducer?.employeeBreakings,
    employeeMobilePunch: state.AttendanceBiometricReducer?.employeeMobilePunch ?? [],
    employeeMobilePunchaAppList: state.AttendanceBiometricReducer?.employeeMobilePunchaAppList ?? [],
    // dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    dropdownAutoMobilepunchList: state.EmployeeDetailsReducer?.dropdownAutoMobilepunchList ?? [],

    loading: state.AttendanceBiometricReducer?.loading,
    error: state.AttendanceBiometricReducer?.error,
    success: state.AttendanceBiometricReducer?.success,
  }));

  useEffect(() => {
    if (authDetails) {
      getAttendanceSalaryDate(authDetails.unit_id).then(response => {
        if (response.status === "success" && response.data.length > 0) {
          const data = response.data[0];
          formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
          formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
        }
      });
    }
  }, [authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    // dispatch(fetchEmployeeDropdownAutoList(unitId))
    dispatch(fetchEmployeeDropdownAutoListMobilePunch(unitId, authUserDetails[0].user_id));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      const formData = new FormData();
      formData.append("from_date", formik.values?.fromDate);
      formData.append("to_date", formik.values?.toDate);
      formData.append("emp_id", modalData?.emp_id);
      dispatch(fetchEmployeeMobilePunchApprovalList(formData));
    }
  }, [authDetails, success, dispatch]);

  useEffect(() => {
    if (employeeMobilePunchaAppList && employeeMobilePunchaAppList.length > 0) {
      const initializedData = (employeeMobilePunchaAppList || []).map(row => ({
        ...row,
        selectedOption: null,
        remarks: "",
        approved_hours: row.worked_hours,
      }));
      setTimesheetApprovalData(initializedData)
    } else {
      setTimesheetApprovalData([]);
      setModal(false)
    }
  }, [employeeMobilePunchaAppList])

  const formik = useFormik({
    initialValues: {
      category: [],
      department: [],
      employee: [],
      fromDate: "",
      toDate: "",
    },
    validationSchema: Yup.object({
      fromDate: Yup.string().nullable().required("From Date is Required"),
      toDate: Yup.string().nullable().required("To Date is Required")
        .test('date-range', 'To Date must be greater than or equal to From Date', function (value) {
          const { fromDate } = this.parent;
          if (!fromDate || !value) return true;
          return new Date(value) >= new Date(fromDate);
        }),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("cat_id", values.category?.value || "0");
      formData.append("dept_id", values.department?.value || "0");
      // formData.append("cat_id", values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0');
      // formData.append("dept_id", values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0');
      // formData.append("desig_id", values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0');
      formData.append("emp_id", values.employee?.value || "0");
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchEmployeeMobilePunch(formData));
    },
  });

  useEffect(() => {
    if (!formik.values.fromDate || !formik.values.toDate) {
      dispatch(resetPunchEmployeeApprovalsList());
      setOpenId(null)
    }
  }, [formik.values.fromDate, formik.values.toDate, dispatch]);

  let punchData = [];
  punchData = employeeMobilePunch.map(emp => ({
    punch_id: emp.punch_id,
    emp_no: emp.emp_no,
    emp_name: emp.emp_name,
    punch_date: emp.punch_date,
    punch_time: emp.punch_time,
    punch_address: emp.punch_address,
    department: emp.department,
    emp_id: emp.emp_id,
    breakings: []
  }));

  const toggleModal = (image, row) => {
    const defaultImage = user1; // Update this path    
    const safeImage = row.original.file_path || defaultImage;
    setSelectedImage(safeImage);
    setModal(!modal);
  };

  useEffect(() => { if (employeeBreakings) { setBreakingDataList(employeeBreakings[0]) } })

  const showBreakings = (data) => {
    setBreakingDataList(data)
    const formData = new FormData();
    formData.append("punch_id", data);
    dispatch(fetchBreakingList(formData));
    setBreakingModal(!breakingmodal);
  };

  const saveMobilePunch = () => {
    const approvalStatusMap = { Approve: "1", Reject: "2", Discussion: "3" };

    const updatedClaims = (timesheetApprovalData || []).filter(item => item.selectedOption).map(item => ({
      punch_id: item.punch_id.toString(),
      approval_status: approvalStatusMap[item.selectedOption] || "0",
      approval_remarks: item.remarks || ""
    }));

    if (updatedClaims.length === 0) {
      showToast({ icon: "warning", title: "No Selection", text: "Please select at least one before proceeding." });
      return;
    }

    const missingRemarksForReject = (timesheetApprovalData || []).filter((item) => item.selectedOption === "Reject" && (!item.remarks || item.remarks.trim() === ""));

    if (missingRemarksForReject.length > 0) {
      const missingList = missingRemarksForReject.map(item => `${item.emp_name} (${item.punch_time})`).join(", ");
      showToast({ icon: "warning", title: "Remarks Required", text: `Please enter remarks for: ${missingList}` });
      return;
    }

    const payload = { listmobilepunch: updatedClaims };
    const convertObject = JSON.stringify(payload);
    const formData = new FormData();
    formData.append("items", convertObject);
    formData.append("create_by", authDetails?.user_id);
    dispatch(updateMobilePunchApprovalRequest(formData))
  };

  const logColumns = [
    { Header: "S No", Cell: ({ row }) => Breakingdata.length - row.index, className: "serial-no text-center", },
    { Header: "Emp Code", accessor: "emp_no" },
    { Header: "Emp Name", accessor: "emp_name" },
    { Header: "Date", accessor: "punch_date" },
    { Header: "Punch Order", accessor: "punch_order" },
    { Header: "Punch Time", accessor: "punch_time" },
    { Header: "Punch Type", accessor: "punch_type" },
  ];

  let Breakingdata = [];
  if (Array.isArray(employeeBreakings)) {
    Breakingdata = employeeBreakings.map(emp => ({
      sno: 1,
      emp_no: emp.emp_no,
      emp_name: emp.emp_name,
      punch_date: emp.punch_date,
      punch_order: emp.punch_order,
      punch_time: emp.punch_time,
      punch_type: emp.punch_type,
    }));
  }

  const handleOptionChange = (rowId, action) => {
    // Update the selected option for the specific row
    const updatedData = timesheetApprovalData.map((row) => {
      if (row.punch_id === rowId) {
        return {
          ...row,
          selectedOption: row.selectedOption === action ? null : action
        };
      }
      return row;
    });

    setTimesheetApprovalData(updatedData);
  };

  const handleRemarksChange = (sno, value) => {
    const updatedData = (timesheetApprovalData || []).map((item) =>
      item.punch_id === sno ? { ...item, remarks: value } : item
    );
    setTimesheetApprovalData(updatedData);
  };

  const handleBulkActionChange = (action) => {
    const allSelected = timesheetApprovalData.every(row => row.selectedOption === action);

    const updatedData = timesheetApprovalData.map((row) => ({
      ...row,
      selectedOption: allSelected ? null : action,
    }));
    setTimesheetApprovalData(updatedData);
  };

  const columns_punch = [
    { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index },

    ...(canApprove ? [

      // =====================
      //  APPROVE COLUMN
      // =====================
      {
        id: "approve",
        Header: () => (
          <div className="text-center">
            Approve <br />
            <Input type="checkbox" name="selectAll" onChange={() => handleBulkActionChange("Approve")} />
          </div>
        ),
        Cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => handleOptionChange(row.original.punch_id, "Approve")}
            style={{ cursor: "pointer" }}
          >
            {row.original.selectedOption === "Approve"
              ? <FaCheck color="green" size={20} />
              : <Input
                type="checkbox"
                name={`action-${row.original.punch_id}`}
                checked={row.original.selectedOption === "Approve"}
              // onChange={() => handleOptionChange(row.original.punch_id, "Approve")}
              />}
          </div>
        )
      },

      // =====================
      //  REJECT COLUMN
      // =====================
      {
        id: "reject",
        Header: () => (
          <div className="text-center">
            Reject <br />
            <Input type="checkbox" name="selectAll" onChange={() => handleBulkActionChange("Reject")} />
          </div>
        ),
        Cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => handleOptionChange(row.original.punch_id, "Reject")}
            style={{ cursor: "pointer" }}
          >
            {row.original.selectedOption === "Reject"
              ? <FaCheck color="red" size={20} />
              : <Input
                type="checkbox"
                name={`action-${row.original.punch_id}`}
                checked={row.original.selectedOption === "Reject"}
              // onChange={() => handleOptionChange(row.original.punch_id, "Reject")}
              />}
          </div>
        )
      },
      // =====================
      //  REMARKS COLUMN
      // =====================
      {
        Header: "Remarks",
        Cell: ({ row }) => {
          const rowIndex = row.index;
          const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.remarks || "");

          const handleBlur = () => {
            if (value) {
              handleRemarksChange(row.original.punch_id, value);
            }
          };

          return (
            <Input
              type="text"
              className="form-control form-control-sm"
              bsSize="sm"
              placeholder="Enter remarks"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onBlur={handleBlur}
            />
          );
        }
      }

    ] : []), // 🔥 Hide approval columns when no access

    //{ Header: "Punch Date", accessor: "punch_date", style={textAlign:"center"} },
    {
      Header: "Punch Date",
      accessor: "punch_date",
      Cell: ({ value }) => (
        <div style={{ textAlign: "center", width: "5px" }}>{value}</div>
      )
    },
    { Header: "Punch Time", accessor: "punch_time", width: "7px" },
    {
      Header: "Image",
      accessor: "file_path",   // make sure this matches your data field
      Cell: ({ value }) => (
        value ? (
          <img
            src={value}
            alt="Punch Image"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "6px",
              textAlign: "center"
            }}
          />
        ) : (
          <span>No Image</span>
        )
      )
    },
    {
      Header: "Punch Address",
      accessor: "punch_address",
      Cell: ({ value }) => (
        <div style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          width: "500px",
          overflowWrap: "anywhere",
          lineHeight: "1.4"
        }}>
          {value}
        </div>
      )
    },

  ];


  const handleView = async (rowData) => {
    const empIdStr = String(rowData?.emp_id);
    const isOpen = openId === empIdStr;
    if (!formik.values.fromDate || !formik.values.toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates before proceeding.",
      });
      return;
    }
    setOpenId(isOpen ? null : empIdStr);
    // Only fetch if not already loaded and not collapsing
    if (!isOpen) {
      const formData = new FormData();
      formData.append("from_date", formik.values?.fromDate);
      formData.append("to_date", formik.values?.toDate);
      formData.append("emp_id", rowData?.emp_id);

      dispatch(fetchEmployeeMobilePunchApprovalList(formData));
      setModalData(rowData);
    }
  };

  const uniquePunchData = punchData.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.emp_id === item.emp_id)
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Biometric" breadcrumbItem="Mobile Punch" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="category">Category</Label>
                          <CustomSelect
                            id="category"
                            name="category"
                            options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                            value={formik.values.category || null}
                            onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                          // isMulti
                          />
                          {formik.touched.category && formik.errors.category && (
                            <div className="text-danger">{formik.errors.category}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="department">Department</Label>
                          <CustomSelect
                            id="department"
                            name="department"
                            options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                            value={formik.values.department || null}  // Store full object
                            onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                          // isMulti
                          />
                          {formik.touched.department && formik.errors.department && (
                            <div className="text-danger">{formik.errors.department}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="employee">Employee</Label>
                          <CustomSelect
                            id="employee"
                            name="employee"
                            options={dropdownAutoMobilepunchList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                            value={formik.values.employee || null}  // Store full object
                            onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                          />
                          {formik.touched.employee && formik.errors.employee && (
                            <div className="text-danger">{formik.errors.employee}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label>
                            From Date <span className="text-danger">*</span>
                          </Label>
                          <CustomDatePicker
                            name="fromDate"
                            value={formik.values.fromDate || null}
                            selected={formik.values.fromDate}
                            onChange={date => formik.setFieldValue("fromDate", date || null)}
                            onBlur={() => formik.setFieldTouched("fromDate", true)}
                          />
                          {formik.touched.fromDate && formik.errors.fromDate && (
                            <div className="text-danger">{formik.errors.fromDate}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label>
                            To Date <span className="text-danger">*</span>
                          </Label>
                          <CustomDatePicker
                            name="toDate"
                            value={formik.values.toDate || null}
                            selected={formik.values.toDate}
                            onChange={date => formik.setFieldValue("toDate", date || null)}
                            onBlur={() => formik.setFieldTouched("toDate", true)}
                          />
                          {formik.touched.toDate && formik.errors.toDate && (
                            <div className="text-danger">{formik.errors.toDate}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-center justify-content-end">
                        <Button type="submit" className="btn button-search me-2">
                          <i className="fas fa-search me-1" /> Search
                        </Button>
                        {/* <Button type="cancel" onClick={formik.handleReset} className="btn button-cancel">
                          <i className="fas fa-sync me-1" /> Cancel
                        </Button> */}
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            showConfirm({
                              title: "Are you sure?", text: "Do you want to Cancel?", confirmText: "Yes, Cancel", cancelText: "No", onConfirm: () => {
                                { formik.handleReset }
                              }
                            });
                          }}
                        >
                          <i className="fas fa-sync me-1" /> Cancel
                        </button>
                      </Col>
                    </Row>
                  </form>

                </CardBody>
              </Card>
            </Col>
          </Row>

          {employeeMobilePunch && employeeMobilePunch.length > 0 && (
            <Card>
              <CardBody>
                <Accordion open={openId} toggle={() => { }} className="w-100">
                  {employeeMobilePunch?.map((emp) => (
                    <AccordionItem className="border-0 box-shadow mb-2" key={emp.emp_id}>
                      <AccordionHeader
                        targetId={String(emp.emp_id)}
                        className={`accordion-header ${openId === String(emp.emp_id) ? 'accordion-open' : ''}`}
                        onClick={() => handleView(emp)}
                      >
                        <div
                          className="timesheet-summary timeaccsheet d-flex flex-wrap justify-content-between align-items-center p-0  mb-0 gap-2"
                          style={{ fontSize: "0.90rem", width: "100%", fontWeight: "600" }}
                        >
                          {/* Employee Info */}
                          <div className="employee-info flex-grow-1">
                            <p className="employee-name mb-0">
                              {emp.emp_name} - {emp.emp_no}
                            </p>
                            <small className="employee-department">
                              {emp.department || "No Department"}
                            </small>
                          </div>

                          {/* Update Button or Placeholder */}
                          <div
                            className="update-button-container"
                            style={{ minWidth: "120px", textAlign: "right" }}
                          >
                            {openId === String(emp.emp_id) ? (
                              <>
                                {/* <Button className="btn btn-sm button-delete me-3" size="sm" onClick={(e) => {  
                                  e.stopPropagation(); // prevent toggle
                                  showBreakings(emp.emp_id);
                                }}>
                                  BREAKINGS
                                </Button> */}
                                {canApprove && (
                                  <Button
                                    type="button"
                                    color="primary"
                                    className="btn btn-sm button-save update-button me-3"
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent accordion toggle
                                      saveMobilePunch()
                                    }}
                                  >
                                    <i className="fas fa-save me-1" /> Update
                                  </Button>
                                )}

                              </>
                            ) : (
                              <div style={{ height: "32px" }}></div>
                            )}
                          </div>
                        </div>
                      </AccordionHeader>

                      <AccordionBody accordionId={String(emp.emp_id)}>
                        <div className="timesheet-table">
                          <TableContainer
                            columns={columns_punch}
                            data={
                              timesheetApprovalData && timesheetApprovalData.length > 0
                                ? timesheetApprovalData
                                : []
                            }
                            isGlobalFilter={true}
                            customPageSize={10}
                          />
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              </CardBody>
            </Card>
          )}
        </Container>

        {/* Modal for Image Preview */}
        <Modal isOpen={modal} toggle={() => setModal(!modal)} className="modalborder-0">
          <ModalHeader toggle={() => setModal(!modal)} className="card-main-title bg-grey"><h6 className="title text-black">Punch Image</h6></ModalHeader>
          <ModalBody className="text-center">
            <img src={selectedImage} alt="Punch" style={{ maxWidth: "100%", borderRadius: "10px" }} />
          </ModalBody>
        </Modal>

        {/* Modal for Breakings Preview */}
        <Modal isOpen={breakingmodal} toggle={() => setBreakingModal(!breakingmodal)} size="xl" className="modalborder-0">
          <ModalHeader toggle={() => setBreakingModal(!breakingmodal)} className="card-main-title bg-grey"><h6 className="title text-black">Punch Breakings</h6></ModalHeader>
          <ModalBody className="text-center">
            <TableContainer
              columns={logColumns}
              data={Breakingdata}
              isGlobalFilter={false}
              customPageSize={10}
              tableSorter={false}
            />
          </ModalBody>
        </Modal>
        <Card>
          <CardBody className="text-center py-4">
            <i className="fas fa-info-circle fa-2x mb-2" />
            <p className="mb-0">No Records Found</p>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default BiometricMobilePunch;
